//@ts-nocheck

import React from 'react'

import { Heading, Paragraph } from '../../../atoms/Typography/Typography.component'
import { Col, Row, SpacerBase, Container } from '../../../atoms/GridSystem'
import Accordion from '../../../molecules/Accordion/Accordion.component'

import * as S from '../Faq.styles'

interface FaqItem {
  question: string
  answer: string
}

interface FaqGroup {
  id?: string
  title?: string
  subtitle?: string
  faqs: FaqItem[]
}

interface FaqSpecifiedProps {
  groups?: FaqGroup[]
}

const FaqSpecified: React.FC<FaqSpecifiedProps> = ({ groups }) => {
  return groups && groups.length > 0
    ? groups.map((item, i) => (
      <Container key={`FaqSpecified-Item-${item?.id}-${i}`}>
        <S.FaqSpecifiedWrapper>
          <Row>
            <Col xs={12} lg={6} $direction="column">
              {item.title ? (
                <Heading typo="displayMD" content={item.title} fontPrimary />
              ) : null}
              {item.subtitle ? (
                <>
                  <Paragraph
                    typo="paragraphLG"
                    content={item.subtitle}
                  />
                  <SpacerBase xs={2} />
                </>
              ) : null}
            </Col>
            <Col xs={12} lg={6}>
              {item.faqs && item.faqs.length > 0 ? (
                <Accordion items={item.faqs} variant="base" withID />
              ) : null}
            </Col>
          </Row>
        </S.FaqSpecifiedWrapper>
      </Container>
    ))
    : null
}

export default FaqSpecified
